import { queryOptions } from '@tanstack/react-query'
import { fetchAccountMapRules } from '../service/accountMapService'
import accountMapQueryKeys from './accountMapQueryKeys'

export const accountMapRulesOptions = (companyId?: string) => {
  return queryOptions({
    queryKey: accountMapQueryKeys.list(companyId!),
    queryFn: fetchAccountMapRules,
    gcTime: 15 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    enabled: !!companyId
  })
}
